<style scoped  lang="less">
  @import 'detailsMatchLine.less'; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding:20vh 0 50vh 0;"  v-if="isloginShow">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
    </div>
    <div v-if="data&&!isloginShow">
      <!-- 球场 -->
      <div class="park" v-if="data.lineupType">
        <div class="title">
          {{data.lineupType==1? langConfig.details[langConfig.curLang]['LINEUP']['STARTING_LINEUP'] : langConfig.details[langConfig.curLang]['LINEUP']['PREDICTED_LINEUP']}}
        </div>
        <!-- 球场 -->
        <div class="ballPark" v-if="data.formatAway||data.formatHome">
          <!-- 左边 -->
          <div class="bp_left">
            <p class="p_lineup">
              {{data.formatHome.split('').join('-')}}
            </p>
            <ul>
              <li v-for="(start_d, start_i) in data.startHomeD" :key="start_i">
                <div class="player" :class="'player_'+start_d.length" v-for="(item, index) in start_d" :key="index">
                  <!-- 升降 -->
                  <span class="p_exponent" v-if="item.changeTime>0">
                      <img :src="require(`@/assets/images/details/match_line/${item.isChanged==1?'out':'up'}.svg`)" />{{item.changeTime}}'
                  </span>
                  <!-- 评分 green red  yellow-->
                  <span class="p_mark" :class="hasMark(item.mark)" v-if="item.mark*1">{{item.mark}}</span>
                  <!-- 头像 -->
                  <div class="playerBox">
                    <!-- <img src="~@/assets/images/details/player.svg" alt=""> -->

                    <img :src="common.playerImgGet(item.player['id'])" @error="handleImageError"  alt="">
                    
                  </div>
                  <p class="p_name">{{item.player.jerseyNumber}}-{{item.player.name}}</p>
                  <!-- 事件 -->
                  <div class="p_incident_l">
                    <template v-for="(event_d, event_i) in item.event_1" >
                      <i :key="event_i" v-if="event_i<3||(event_i==3&&item.event_1.length==4)">
                        <img :title="event_d" :src="require(`@/assets/images/details/match_line/${event_d}.svg`)" />
                      </i> 
                    </template> 
                    <i v-if="item.event_1&&item.event_1.length>4"><img src="~@/assets/images/details/omit.svg" /></i>
                  </div>
                  <div class="p_incident_r"> 
                    <template v-for="(event_d2, event_i2) in item.event_2" >
                      <i :key="event_i2" v-if="event_i2<3||(event_i2==3&&item.event_2.length==4)">
                        <img :title="event_d2" :src="require(`@/assets/images/details/match_line/${event_d2}.svg`)" />
                      </i> 
                    </template> 
                    <i v-if="item.event_2&&item.event_2.length>4"><img src="~@/assets/images/details/omit.svg" /></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="bp_right"> 
            <p class="p_lineup">
              {{data.formatAway.split('').join('-')}}
            </p>
            <ul>

              <li v-for="(start_d, start_i) in data.startAwayD" :key="start_i">
                <div class="player" :class="'player_'+start_d.length"  v-for="(item, index) in start_d" :key="index">
                  <!-- 升降 -->
                  <span class="p_exponent" v-if="item.changeTime>0&&item.isChanged==1">
                      <img :src="require(`@/assets/images/details/match_line/${item.isChanged==1?'out':'up'}.svg`)" />{{item.changeTime}}'
                  </span>
                  <!-- 评分 green red  yellow-->
                  <span class="p_mark" :class="hasMark(item.mark)" v-if="item.mark*1">{{item.mark}}</span>
                  <!-- 头像 --> 
                  <div class="playerBox">
                    <!-- <img src="~@/assets/images/details/player.svg" alt=""> -->
                    <img :src="common.playerImgGet(item.player['id'])"  @error="handleImageError" alt="">
                  </div>
                  <p class="p_name">{{item.player.jerseyNumber}}-{{item.player.name}}</p>
                  <!-- 事件 -->
                  <div class="p_incident_l">
                    <template v-for="(event_d, event_i) in item.event_1" >
                      <i :key="event_i" v-if="event_i<3||(event_i==3&&item.event_1.length==4)">
                        <img :title="event_d"  :src="require(`@/assets/images/details/match_line/${event_d}.svg`)" />
                      </i> 
                    </template> 
                    <i v-if="item.event_1&&item.event_1.length>4"><img src="~@/assets/images/details/omit.svg" /></i>
                  </div>
                  <div class="p_incident_r"> 
                    <template v-for="(event_d2, event_i2) in item.event_2" >
                      <i :key="event_i2" v-if="event_i2<3||(event_i2==3&&item.event_2.length==4)">
                        <img :title="event_d2"  :src="require(`@/assets/images/details/match_line/${event_d2}.svg`)" />
                      </i> 
                    </template> 
                    <i v-if="item.event_2&&item.event_2.length>4"><img src="~@/assets/images/details/omit.svg" /></i>
                  </div>
                </div>
              </li>



              <li v-if="false">
                <div class="player">
                  <!-- 升降 -->
                  <div class="p_exponent">
                    <img src="~@/assets/images/details/match_line/out.svg" />80’
                  </div>
                  <!-- 评分 green red  yellow-->
                  <div class="p_mark">1.0</div>
                  <!-- 头像 -->
                  <div class="playerBox">
                    <img src="~@/assets/images/details/player.svg" alt="">
                  </div>
                  <p class="p_name">名字</p>
                  <!-- 事件 -->
                  <div class="p_incident_l">
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                  </div>
                  <div class="p_incident_r">
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/omit.svg" /></i>
                  </div>
                </div>
              </li>
            
            </ul>
          </div>
        </div>
      </div>
      <!-- 本场换人-->
      <div class="substitution" v-if="data.subAway||data.subHome">
        <div class="title">
          {{ langConfig.details[langConfig.curLang]['LINEUP']['SUBSTITUTIONS'] }}
        </div>
        <div class="listBox">
          <ul>
            <template v-if="data.subHome">
              <template v-for="(item, index) in data.subHome" >
                <li :key="index" v-if="item['playerUp']&&item['playerDown']">
                  <div class="player">
                    <div class="p_time">
                      {{item['playerUp']['changeTime']}}'
                    </div>
                    <div class="imgBox">
                      <img :src="common.playerImgGet(item['playerUp']['player']['id'])"  @error="handleImageError" alt="">
                    </div>
                    <div class="text">
                      <p class="p_name" :title="item['playerUp']['player']['name']"> <img src="~@/assets/images/details/match_line/up.svg" />{{item.playerUp.player.jerseyNumber}}-{{item['playerUp']['player']['name']}}</p>
                      <p class="p_name_out" :title="item['playerDown']['player']['name']"> <img src="~@/assets/images/details/match_line/out.svg" />{{item.playerDown.player.jerseyNumber}}-{{item['playerDown']['player']['name']}}</p>
                      <p class="p_orientation" :title="item['playerUp']['player']['positionName']">{{item['playerUp']['player']['positionName']}}</p>
                    </div>
                  </div>
                  <div class="message">
                    <img src="~@/assets/images/details/match_line/up.svg" />
                    {{item['playerUp']['changeTime']}}'
                    <img src="~@/assets/images/details/match_line/out.svg" />
                  </div>
                  <div class="player ">
                    <div class="imgBox" v-if="item['playerDown']">
                      <img :src="common.playerImgGet(item['playerDown']['player']['id'])" @error="handleImageError"  alt="">
                    </div>
                    <div class="text">
                      <p class="p_name p_name_r" :title="item['playerDown']['player']['name']">{{item.playerDown.player.jerseyNumber}}-{{item['playerDown']['player']['name']}}</p>
                      <p class="p_orientation" :title="item['playerDown']['player']['positionName']">{{item['playerDown']['player']['positionName']}}</p>
                    </div>
                  </div>
                </li>
              </template>
            </template>
          
          </ul>
          <ul>
            <template v-if="data.subAway">
              <template v-for="(item, index) in data.subAway" >
                <li :key="index" v-if="item['playerUp']&&item['playerDown']">
                  <div class="player">
                    <div class="p_time">
                      {{item['playerUp']['changeTime']}}'
                    </div>
                    <div class="imgBox">
                      <img :src="common.playerImgGet(item['playerUp']['player']['id'])"  @error="handleImageError" alt="">
                    </div>
                    <div class="text">
                      <p class="p_name" :title="item['playerUp']['player']['name']"> <img src="~@/assets/images/details/match_line/up.svg" />{{item.playerUp.player.jerseyNumber}}-{{item['playerUp']['player']['name']}}</p>
                      <p class="p_name_out" :title="item['playerDown']['player']['name']"> <img src="~@/assets/images/details/match_line/out.svg" />{{item.playerDown.player.jerseyNumber}}-{{item['playerDown']['player']['name']}}</p>
                      <p class="p_orientation" :title="item['playerUp']['player']['positionName']">{{item['playerUp']['player']['positionName']}}</p>
                    </div>
                  </div>
                  <div class="message">
                    <img src="~@/assets/images/details/match_line/up.svg" />
                    {{item['playerUp']['changeTime']}}'
                    <img src="~@/assets/images/details/match_line/out.svg"/>
                  </div>
                  <div class="player ">
                    <div class="imgBox" v-if="item['playerDown']">
                      <img :src="common.playerImgGet(item['playerDown']['player']['id'])" @error="handleImageError"  alt="">
                    </div>
                    <div class="text">
                      <p class="p_name p_name_r" :title="item['playerDown']['player']['name']">{{item.playerDown.player.jerseyNumber}}-{{item['playerDown']['player']['name']}}</p>
                      <p class="p_orientation" :title="item['playerDown']['player']['positionName']">{{item['playerDown']['player']['positionName']}}</p>
                    </div>
                  </div>
                </li>
              </template>
            </template>
          </ul>
        </div>

      </div>

      <!-- 本场替补 -->
      <div class="substitute" v-if="data.backupAway||data.backupHome">
        <div class="title">
          {{ langConfig.details[langConfig.curLang]['LINEUP']['THE_BENCH_PLAYERS'] }}
        </div>
        <!-- 列表 -->
        <div class="listBox">
          <ul>
            <li v-for="(item, index) in data.backupHome" :key="index" :style="!item['player'].name?'display: none;':''">
              <div class="imgBox">
                <!-- playerImgGet -->
                  <img :src="common.playerImgGet(item['player']['id'])"  @error="handleImageError" alt="">
                </div>
                <div class="text">
                  <p class="p_name">
                    <span class="p1" :title="item['player'].name">{{item.player.jerseyNumber}}-{{item['player'].name}}</span>
                    <span class="p_exponent" v-if="item.changeTime>0">
                      <img :src="require(`@/assets/images/details/match_line/up.svg`)" />
                      {{item.changeTime}}'
                    </span>
                  </p>
                  <p class="p_orientation">
                    <span class="p1" :title="item['player'].positionName">{{item['player'].positionName}}</span>
                    <span class="p_mark" :class="hasMark(item.mark)" v-if="item.mark*1">{{item.mark}}</span>
                    <template v-for="(event_d, event_i) in item.event_1" >
                      <i 
                      :key="event_i" 
                      v-if="
                        ((item.event_1.length>2)&&event_i==0)
                        ||item.event_1.length<3
                      ">
                        <b v-if="item.event_1.length>2">
                          {{item.event_1.length}}
                        </b>
                        <img :src="require(`@/assets/images/details/match_line/${event_d}.svg`)" />
                      </i>
                    </template>
                    <template v-for="(event_d2, event_i2) in item.event_2" >
                      <i class="i_on" :key="event_i2">
                        <img :src="require(`@/assets/images/details/match_line/${event_d2}.svg`)" />
                      </i>
                    </template>
                  </p>
                </div>
            </li>
            <!-- <li>
              <div class="imgBox">
                  <img src="~@/assets/images/details/player.svg" alt="">
                </div>
                <div class="text">
                  <p class="p_name">
                    <span class="p1">9-Erling Haaland</span>
                    <span class="p_exponent">
                      <img src="~@/assets/images/details/match_line/out.svg" />80’
                    </span>
                  </p>
                  <p class="p_orientation">
                    <span class="p1">Forwards</span>
                    <span class="p_mark">1.0</span>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                    <i><img src="~@/assets/images/details/match_line/1.svg" /></i>
                  </p>
                </div>
            </li> -->
          
          </ul>
          <ul>
            <li  v-for="(item, index) in data.backupAway" :key="index" :style="!item['player'].name?'display: none;':''">
              <div class="imgBox">
                <!-- playerImgGet -->
                  <img :src="common.playerImgGet(item['player']['id'])"  @error="handleImageError" alt="">
                </div>
                <div class="text">
                  <p class="p_name">
                    <span class="p1" :title="item['player'].name">{{item.player.jerseyNumber}}-{{item['player'].name}}</span>
                    <span class="p_exponent" v-if="item.changeTime>0">
                      <img :src="require(`@/assets/images/details/match_line/up.svg`)" />{{item.changeTime}}'
                    </span>
                  </p>
                  <p class="p_orientation">
                    <span class="p1" :title="item['player'].positionName">{{item['player'].positionName}}</span>
                    <span class="p_mark" :class="hasMark(item.mark)" v-if="item.mark*1">{{item.mark}}</span>
                    <template v-for="(event_d, event_i) in item.event_1" >
                      <i 
                      :key="event_i" 
                      v-if="
                        ((item.event_1.length>2)&&event_i==0)
                        ||item.event_1.length<3
                      ">
                        <b v-if="item.event_1.length>2">
                          {{item.event_1.length}}
                        </b>
                        <img :src="require(`@/assets/images/details/match_line/${event_d}.svg`)" />
                      </i>
                    </template>
                    <template v-for="(event_d2, event_i2) in item.event_2" >
                      <i class="i_on" :key="event_i2">
                        <img :src="require(`@/assets/images/details/match_line/${event_d2}.svg`)" />
                      </i>
                    </template>
                  </p>
                </div>
            </li>
          </ul>

        </div>
      </div>
      <div class="no-data" v-else>
          <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
          <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
        </div>
      <!-- 标注 -->
      <div class="labelBox">
        <p>
          <img src="~@/assets/images/details/match_line/1.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['GOALS_SCORED'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/2.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['PENALTY'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/3.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['OWN_GOALS'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/4.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['YELLOW_CARDS'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/6.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['RED_CARDS'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/up.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['IN'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/out.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['OUT'] }}
        </p>
        <p>
          <img src="~@/assets/images/details/match_line/5.svg" />
          {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['2Y_TO_R'] }}
        </p>
      </div>

    
      
    </div>
  </div>
</template>

<script>
import { getMatchLineup } from '@/api/api';
export default {
  components: {
    
  },
  data() {
    return {
      isReadTime:0,
      isloginShow:true,
      baseParam:{ 
          userToken: '',
      },
      data:null,
    };
  },
  methods: { 
    logdingFlag(){
      if(typeof(window) != 'undefined' && this.isloginShow){
        return true;
      }
      return false;
    },
    handleImageError(event) {
      // 加载失败时切换到默认图片
      event.target.src = require(`@/assets/images/details/player.svg`);
    },
    //Mark颜色赋值
    hasMark(val){
      return val
      ? val < 6 ? ''
      : val < 7 ? 'green'
      : val < 8.5 ? 'yellow'
      : 'red'
      : '';
      
    },

    //数据清洗
    dataCleaning(res){
      let data=JSON.parse(JSON.stringify(res));
      //替补
      let backupHome=data.backupHome||null;
      let backupAway=data.backupAway||null;
      if(backupHome){
        backupHome.forEach((d, i) => {
          if(d.event){
            d.event_1=d.event.filter(x => [1,2,3].includes(x));
            d.event_2=d.event.filter(x => [4,5,6].includes(x));
          }
        });
      }
      if(backupAway){
        backupAway.forEach((d, i) => {
          if(d.event){
            d.event_1=d.event.filter(x => [1,2,3].includes(x));
            d.event_2=d.event.filter(x => [4,5,6].includes(x));
          }
        });
      }
      //换人
      let formatAway=data.formatAway||null;
      let formatHome=data.formatHome||null;
      data.startHomeD=[];
      data.startAwayD=[];
      if(formatHome){
        let formatSplit=(1+''+formatHome).split('');
        data.startHome.forEach((d, i) => {
          // d.event=[1,2,3,4,5,6,7,8,9]
          if(d.event){
            d.event_1=d.event.filter(x => [1,2,3].includes(x)).slice().reverse();
            d.event_2=d.event.filter(x => [4,5,6].includes(x));
          }
        });
        var start = 0;
        for (let i = 0; i < formatSplit.length; i++) {
          const end = start*1 + formatSplit[i]*1;
          data.startHomeD.push(data.startHome.slice(start, end));
          start = end;
        }
      }
      if(formatAway){
        let formatSplit=(1+''+formatAway).split('');
        data.startAway.forEach((d, i) => {
          // d.event=[1,2,3,1,2,3,4,5,6,4,5,6,7,8,9]
          if(d.event){
            d.event_1=d.event.filter(x => [1,2,3].includes(x)).slice().reverse();
            d.event_2=d.event.filter(x => [4,5,6].includes(x));
          }
        });
        var start = 0;
        for (let i = 0; i < formatSplit.length; i++) {
          const end = start*1 + formatSplit[i]*1;
          data.startAwayD.push(data.startAway.slice(start, end));
          start = end;
        }
      }
      return data;
    },

    //数据读取
    async getMatchLineupData(){
        let obj={
          matchId:this.matchId,
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        console.log('getMatchLineup_param',param);
        await getMatchLineup(param).then((res) => {
          this.isloginShow=false;
          console.log('getMatchLineup_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchLineup_data',data);
          //data.backupAway||data.backupHome"
          if(data){
            this.data=this.dataCleaning(data);
          }
          
          // let stats=(data.stats||[]);
          // let statsObj = {};
          // stats.forEach((stats_i, index) => {
          //   statsObj[stats_i.id] = {
          //     ...stats_i,
          //     ...{index:index}
          //   };
          // });
          // _this.statsList=data.stats;
          // _this.statsObj=statsObj;
          //console.log('getMatchSta-stats',stats);
          //console.log('getMatchSta-statsObj',statsObj);
        }).catch((res) => {
          console.error(res);
        })
    },
    init(){
      if(!this.matchId){
        return;
      } 
      //console.log(123123);
      this.getMatchLineupData();
    }
     
  },
  created() {
    this.isReadTime=this.isRead;
    this.init();
  
  },
  watch: {
    isRead(val){
      if(val!=this.isReadTime){
        this.init();
        this.isReadTime=val;

        console.log('MatchLine-数据重置');
      }
    },
    matchId(){
      //this.init(); 
      //console.log('matchId','11111');
    },
    // socketStatsList(val){
    //   var list=val||[];
    //   if(list.length>0){
    //     this.statsList=val;
    //   }
    // },
  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    // options:{
    //   type:Array,
    //   default:() =>[],
    // },
    // format: {
    //   type: String,
    //   default:'DD/MM/YYYY WW'
    // },
    // showToday:{
    //   type: Boolean,
    //   default:false
    // },

    //socket推送
    // socketStatsList: {
    //   type: Object,
    //   default: () => {},
    // },
    // socketStatsList
    matchId: {
      type: Number,
      default:null
    },
    isRead: {
      type: Number,
      default: 0,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsMatchLine.vue